export const CARRIER_TRANSLATIONS: Record<string, string> = {
  'СТС / регистрация автомобиля': 'Vehicle registration certificate',
  'Документы компании': 'Company documents',
  'Требуются исправления': 'Changes required',
  'Истёк срок документов': 'Documents expired',
  'Сейчас в портфолио:': 'Portfolio now:',
  'фото · ориентир для топ-перевозчика: 40+ фото': 'photos · top carriers usually have 40+ photos',
  ', отклики заблокированы': ', offers are blocked',
  '← К заявке': '← Back to request',
  '← К чату': '← Back to chat',
  '+ ещё': '+ more',
  '+ Комиссия LOVO (5%)': '+ LOVO fee (5%)',
  '= Цена для клиента': '= Customer price',
  '⚠ Загрузите фото текущего этапа — это улучшит рейтинг фото.': '⚠ Upload a photo for the current stage to improve your photo rating.',
  '✓ Верифицирован': '✓ Verified',
  'Банк': 'Bank',
  'В кабинете': 'In your account',
  'В кабинете, по email и SMS': 'In your account, by email and SMS',
  'Ваша оценка заказчика': 'Your customer rating',
  'Ваша цена': 'Your price',
  'Ваша цена за поездку': 'Your price for the trip',
  'Внутренний баланс LOVO': 'LOVO account balance',
  'Водительские права': 'Driving licence',
  'Возвращён': 'Refunded',
  'Возвращены': 'Refunded',
  'Возможно, она уже закрыта или больше недоступна.': 'It may already be closed or no longer available.',
  'Вопрос по оплате': 'Payment question',
  'Вопросы по заявкам': 'Request questions',
  'Все ваши перевозки': 'All your transports',
  'Вывести на карту через поддержку': 'Withdraw to a bank card through support',
  'Вывод с внутреннего баланса': 'Balance withdrawal',
  'Вывод средств с внутреннего баланса LOVO': 'Withdraw funds from your LOVO balance',
  'Выезд до': 'Departure to',
  'Выезд от': 'Departure from',
  'Выставлен': 'Issued',
  'Готова к старту': 'Ready to start',
  'Грызуны': 'Rodents',
  'Данные других перевозчиков скрыты до отправки вашего отклика.': 'Other carriers’ details are hidden until you submit your offer.',
  'Есть ответ': 'Answered',
  'Дата': 'Date',
  'Движение внутреннего баланса': 'Balance activity',
  'дд.мм.гггг': 'dd.mm.yyyy',
  'Деньги и счета': 'Money and invoices',
  'Детали заявки': 'Request details',
  'Добавить контрольную точку с фото или видео': 'Add a checkpoint with a photo or video',
  'Добавляйте контрольные точки с фото на каждом этапе — это повышает рейтинг фото и доверие заказчиков': 'Add photo checkpoints at every stage to improve your photo rating and customer trust',
  'Добавляйте фото на каждой контрольной точке перевозки — чем полнее хроника поездки, тем выше рейтинг.': 'Add photos at every transport checkpoint. A more complete journey record improves your rating.',
  'Документы и переписка доступны только участникам сделки и команде LOVO.': 'Documents and messages are visible only to the deal participants and the LOVO team.',
  'Доставлено': 'Delivered',
  'Доставлено · ждём подтверждение оплаты': 'Delivered · awaiting payment confirmation',
  'Доставлено · оплата подтверждена заказчиком': 'Delivered · payment confirmed by customer',
  'Если заявка отменена до выезда — комиссия не взимается. Если после — обратитесь в поддержку для разбора ситуации.': 'No fee is charged if a request is cancelled before departure. Contact support if it is cancelled later.',
  'Если срок действия документа истёк или данные изменились — загрузите новую версию. Проверка обычно занимает до 24 часов.': 'Upload a new version if a document has expired or its details have changed. Review usually takes up to 24 hours.',
  'Есть вопросы к состоянию питомца при передаче': 'There are concerns about the pet’s condition at handover',
  'Завершено': 'Completed',
  'Завершённая перевозка': 'Completed transport',
  'Загружаем заявку...': 'Loading request…',
  'Загрузите фото текущего этапа — это улучшит рейтинг фото и повысит шанс выбора в следующих заявках': 'Upload a photo for the current stage to improve your photo rating and your chances of being selected next time',
  'Загрузить файлы': 'Upload files',
  'Заказчик не готов к передаче или не выходит на связь': 'The customer is not ready for handover or cannot be reached',
  'Заказчик пока не оставил отзыв.': 'The customer has not left a review yet.',
  'Заменить': 'Replace',
  'Заявки на ваших маршрутах и по всей базе LOVO': 'Requests on your routes and across LOVO',
  'Заявки на ваших маршрутах отмечены — по ним у вас больше шансов на выбор': 'Requests on your routes are marked because you have a better chance of being selected',
  'Пока нет открытых заявок на ваших маршрутах.': 'There are no open requests on your routes yet.',
  'ИНН': 'Tax ID',
  'Истёк': 'Expired',
  'История счетов': 'Invoice history',
  'К отклику автоматически прикрепится:': 'Your offer will automatically include:',
  'К получению': 'To receive',
  'Как повысить рейтинг фото?': 'How can I improve my photo rating?',
  'Как рассчитывается комиссия LOVO?': 'How is the LOVO fee calculated?',
  'Когда я получу оплату за перевозку?': 'When will I receive payment?',
  'Кого везти': 'Pets to transport',
  'Комиссия составляет 5% от суммы перевозки и автоматически формируется в виде счёта после завершения заказа.': 'The fee is 5% of the transport price and is invoiced automatically after completion.',
  'Комиссия уплачена всего': 'Total fees paid',
  'Комиссия LOVO': 'LOVO fee',
  'Комментарий заказчику': 'Message to customer',
  'Кошки': 'Cats',
  'КПП': 'Tax registration code',
  'Лицензия ИП': 'Business licence',
  'Любой город': 'Any city',
  'международ': 'international',
  'Международная лицензия': 'International licence',
  'Мои отклики': 'My offers',
  'На проверке': 'Under review',
  'На сумму комиссии автоматически формируется счёт': 'An invoice is generated automatically for the fee',
  'Назначение платежа': 'Payment reference',
  'Нарушены сроки': 'Deadline missed',
  'Настроить': 'Configure',
  'Настроить уведомления': 'Configure notifications',
  'Настройки уведомлений': 'Notification settings',
  'Начать перевозку': 'Start transport',
  'Не загружен': 'Not uploaded',
  'Не удалось открыть заявку': 'Could not open the request',
  'Нет открытых счетов. Баланс доступен для расчётов по завершённым перевозкам.': 'There are no open invoices. Your balance is available for completed transport settlements.',
  'Найти заявку': 'Find a request',
  'Новые заявки на ваших маршрутах': 'New requests on your routes',
  'Новые заявки на маршрутах': 'New route requests',
  'Новые отклики и заявки': 'New offers and requests',
  'Нужно обновить документы?': 'Need to update your documents?',
  'Обновить документы': 'Update documents',
  'Сохранить документы': 'Save documents',
  'Сохраняем…': 'Saving…',
  'Документы сохранены ✓': 'Documents saved ✓',
  'Не удалось сохранить документы. Попробуйте ещё раз.': 'Could not save the documents. Please try again.',
  'Ожидает': 'Pending',
  'Ожидает согласования': 'Awaiting approval',
  'Ожидают': 'Pending',
  'Операция': 'Transaction',
  'Опишите ситуацию в чате поддержки — мы рассмотрим детали заявки, переписку и фото с контрольных точек.': 'Describe the situation in support chat. We will review the request, messages and checkpoint photos.',
  'Опишите ситуацию подробно': 'Describe the situation in detail',
  'Опишите ситуацию свободно': 'Describe the situation',
  'Оплата не поступила или сумма не совпадает': 'Payment was not received or the amount is incorrect',
  'Оплата поступает на внутренний баланс LOVO сразу после подтверждения заказчиком получения питомца, обычно в течение нескольких минут.': 'Payment reaches your LOVO balance after the customer confirms delivery, usually within a few minutes.',
  'Оплатить можно картой или списанием с внутреннего баланса': 'Pay by card or from your LOVO balance',
  'Оплачен': 'Paid',
  'Оплачены': 'Paid',
  'Отзыв заказчика о вас': 'Customer review about you',
  'Отзыв отправлен': 'Review sent',
  'Оставить отзыв позже': 'Leave a review later',
  'Отклик актуален до': 'Offer valid until',
  'Отклик отправлен': 'Offer sent',
  'отклики на новые заявки заблокированы.': 'offers for new requests are blocked.',
  'Откликнуться': 'Send offer',
  'Отклонён': 'Declined',
  'Отклонены': 'Declined',
  'Отменён': 'Cancelled',
  'Отменить': 'Cancel',
  'Отправить отклик': 'Send offer',
  'Паспорт': 'Passport',
  'Перевозка завершена. Ваш отзыв поможет другим перевозчикам.': 'The transport is complete. Your review will help other carriers.',
  'Перевозок выполнено': 'Transports completed',
  'Перевозок завершено': 'Transports completed',
  'Передали питомца? Закрываем сделку': 'Pet handed over? Complete the deal',
  'Передача питомца': 'Pet handover',
  'Плюс одна перевозка уже в пути.': 'One more transport is already in progress.',
  'Подавайте спор только если действительно есть проблема. Модератор LOVO разберёт обращение в течение 24 часов.': 'Open a dispute only when there is a genuine problem. A LOVO moderator will review it within 24 hours.',
  'Подготовка питомца и документов': 'Preparing the pet and documents',
  'Подробнее →': 'Details →',
  'Подтверждён ✓': 'Confirmed ✓',
  'Поиск заявок': 'Find requests',
  'Пока счёт не оплачен — новые отклики отправлять нельзя': 'You cannot send new offers until the invoice is paid',
  'Пока счёт не оплачен, вы не можете отправлять новые отклики на заявки': 'You cannot send new request offers until the invoice is paid',
  'Полезные материалы': 'Useful resources',
  'После доставки заказчик подтвердит получение, и оплата поступит на ваш баланс': 'After delivery, the customer confirms receipt and payment reaches your balance',
  'После этой даты отклик автоматически скроется из списка заказчика': 'After this date, the offer will automatically disappear from the customer’s list',
  'Предложат': 'Carriers quote',
  'Приватные чаты с заказчиками по вашим сделкам': 'Private chats with customers about your deals',
  'Применить': 'Apply',
  'Принят': 'Accepted',
  'Приняты': 'Accepted',
  'Просрочен': 'Overdue',
  'Просрочены': 'Overdue',
  'Прямая оплата согласована': 'Direct payment agreed',
  'Птицы': 'Birds',
  'Р/с': 'Account number',
  'Разобраться в ситуации': 'Review the situation',
  'Расскажите о своём опыте перевозки животных, условиях в пути и т.д.': 'Describe your pet transport experience, travel conditions and other details.',
  'Расскажите, как прошло': 'Tell us how it went',
  'Расскажите как прошло': 'Tell us how it went',
  'Рейтинг': 'Rating',
  'Рейтинг фото': 'Photo rating',
  'Реквизиты LOVO': 'LOVO payment details',
  'С каждой завершённой перевозки удерживается комиссия LOVO 5%': 'LOVO charges a 5% fee for each completed transport',
  'С каждой перевозки удерживается 5% — счёт формируется автоматически и должен быть оплачен для новых откликов': 'A 5% fee is charged for each transport. The invoice is generated automatically and must be paid before sending new offers.',
  'С отзывом': 'With a review',
  'свежая заявка': 'new request',
  'свежие заявки': 'new requests',
  'свежих заявок': 'new requests',
  'Сейчас у вас нет активных перевозок. Найдите подходящую заявку в ленте поиска и отправьте отклик.': 'You have no active transports. Find a suitable request in the feed and send an offer.',
  'Сейчас у вас нет активных перевозок. Откликайтесь на заявки, чтобы взять заказ.': 'You have no active transports. Send offers to accept a job.',
  'Селфи с паспортом': 'Selfie with passport',
  'Скачать реквизиты LOVO': 'Download LOVO payment details',
  'Скачать PDF-счёт': 'Download invoice PDF',
  'Сколько вы хотите за поездку?': 'How much do you want for the trip?',
  'Сначала дешевле': 'Lowest price first',
  'Сначала дороже': 'Highest price first',
  'Сначала новые': 'Newest first',
  'Сначала старые': 'Oldest first',
  'Собаки': 'Dogs',
  'Соблюдение договорённостей': 'Following agreements',
  'Спорные': 'Disputed',
  'Споры и решения': 'Disputes and decisions',
  'Списать на оплату счёта': 'Use balance to pay invoice',
  'Списать с внутреннего баланса': 'Pay from LOVO balance',
  'Пополнить баланс': 'Top up balance',
  'Пополняем…': 'Adding funds…',
  'Сумма пополнения': 'Top-up amount',
  'Тестовое пополнение без списания денежных средств': 'Test top-up without charging real money',
  'После подтверждения сумма будет сразу записана во внутренний баланс и историю операций.': 'After confirmation, the amount is added to your balance and transaction history immediately.',
  'Тестовое пополнение баланса': 'Test balance top-up',
  'Срок': 'Due date',
  'Сроки изменены без предварительного согласования': 'Dates changed without prior agreement',
  'Статистика перевозчика': 'Carrier statistics',
  'Статус ваших предложений по заявкам заказчиков': 'Status of your customer request offers',
  'Статус верификации ваших документов перевозчика': 'Verification status of your carrier documents',
  'Статус оплаты': 'Payment status',
  'Статусы перевозки': 'Transport statuses',
  'Сумма': 'Amount',
  'Сумма счёта': 'Invoice amount',
  'Фактические условия отличаются от заявки': 'Actual conditions differ from the request',
  'Фильтр истории': 'History filter',
  'Фильтр откликов': 'Offer filter',
  'Фильтр счетов': 'Invoice filter',
  'Финансы по перевозке': 'Transport finances',
  'Фото из портфолио': 'Portfolio photos',
  'Фото этапа': 'Stage photo',
  'Чат с заказчиком': 'Customer chat',
  'Чат выбранной сделки': 'Selected deal chat',
  'Приватные переговоры до выбора перевозчика. Стоимость и условия видны только вам и заказчику.': 'Private negotiations before the carrier is selected. The price and terms are visible only to you and the customer.',
  'Заказчик выбрал другого перевозчика. История переговоров доступна только для чтения.': 'The customer selected another carrier. The conversation history is read-only.',
  'Чистая прибыль': 'Net earnings',
  'чистыми': 'net',
  'Что делать при споре с заказчиком?': 'What should I do in a customer dispute?',
  'Что делать, если заказчик отменил заявку?': 'What if the customer cancels the request?',
  'Что понравилось, что можно улучшить': 'What went well and what could be improved',
  'Что происходит по вашим заявкам и сделкам': 'Activity for your requests and deals',
  'Этот год': 'This year',
  'Я доставил питомца': 'I delivered the pet',
  'К счетам и балансу': 'Invoices and balance',
  'Сейчас отправка откликов недоступна. Проверьте неоплаченные счета в биллинге.': 'Offers are currently unavailable. Check your unpaid invoices.',
  'Погасите блокирующие счета перед отправкой нового отклика.': 'Pay the blocking invoices before sending another offer.',
  'Чтобы отправлять отклики, сначала завершите верификацию перевозчика.': 'Complete carrier verification before sending offers.',
  'Чтобы отправлять отклики, завершите верификацию перевозчика и погасите блокирующие счета.': 'Complete carrier verification and pay blocking invoices before sending offers.',
  'К счетам →': 'Invoices →',
  '← К списку заявок': '← Back to requests',
  'Вернуться к списку': 'Back to list',
  'Все →': 'All →',
  'Все заявки': 'All requests',
  'Завершенные': 'Completed',
  'На моих маршрутах': 'On my routes',
  '№ счёта': 'Invoice no.',
  '✓ Я получил оплату — закрыть сделку': '✓ I received payment · close deal',
  'Найти ответ в справке...': 'Search help…',
  'Написать в чат поддержки': 'Contact support chat',
  'Наша поддержка на связи ежедневно с 8:00 до 22:00 по московскому времени': 'Support is available daily from 8 a.m. to 10 p.m. Moscow time',
  'Не нашли ответ?': 'Could not find an answer?',
  'Ответы на частые вопросы и связь со службой заботы LOVO': 'Frequently asked questions and LOVO support',
  'Поддержка': 'Support',
  'Ваши обращения и ответы операторов LOVO': 'Your support requests and responses from LOVO operators',
  'Новое обращение': 'New request',
  'Обращения в поддержку': 'Support requests',
  'Тема вопроса': 'Topic',
  'Заголовок': 'Subject',
  'Коротко опишите вопрос': 'Briefly describe the issue',
  'Сообщение': 'Message',
  'Расскажите, что произошло': 'Tell us what happened',
  'Отправить обращение': 'Submit request',
  'Отправляем…': 'Sending…',
  'К обращениям': 'Back to requests',
  'Открыть снова': 'Reopen',
  'Закрыть обращение': 'Close request',
  'Напишите сообщение поддержке': 'Write a message to support',
  'Загружаем обращения…': 'Loading requests…',
  'Обращений пока нет. Создайте первое, если понадобится помощь.': 'No support requests yet. Create one if you need assistance.',
  'Правила сервиса для перевозчиков': 'Service rules for carriers',
  'Удаление аккаунта приведёт к безвозвратной потере всех данных, рейтинга и истории поездок': 'Deleting your account permanently removes all data, ratings and trip history',
  'Удалить аккаунт': 'Delete account',
  'Частые вопросы': 'Frequently asked questions',
  '+ Добавить маршрут': '+ Add route',
  '+ Добавить фото': '+ Add photo',
  'Авиакурьер': 'Flight courier',
  'Автомобиль': 'Vehicle',
  'Автоперевозки': 'Road transport',
  'Будет видно пользователям': 'Visible to users',
  'Верификация не завершена': 'Verification incomplete',
  'Видеоотзывы': 'Video reviews',
  'Впишите через запятую': 'Enter values separated by commas',
  'Встреча питомца': 'Pet meet-and-greet',
  'г.': 'year',
  'Год выпуска': 'Year',
  'Город отправления': 'Departure city',
  'Город прибытия': 'Arrival city',
  'Добавить описание': 'Add description',
  'Добавить контрольную точку': 'Add checkpoint',
  'Расскажите заказчику, как проходит поездка, и приложите фото или видео.': 'Tell the customer how the journey is going and attach photos or videos.',
  'Название этапа': 'Stage name',
  'Например: остановка в Туле': 'For example: a stop in Tula',
  'Дата и время': 'Date and time',
  'Комментарий': 'Comment',
  'Состояние питомца, кормление, прогулка и другие важные детали': 'Pet condition, feeding, walks and other important details',
  'Фото и видео': 'Photos and videos',
  'Добавить фото или видео': 'Add photos or videos',
  'JPG, PNG, WEBP до 10 МБ; MP4, MOV, WEBM до 200 МБ. Не более 6 файлов.': 'JPG, PNG and WEBP up to 10 MB; MP4, MOV and WEBM up to 200 MB. Up to 6 files.',
  'Создать точку': 'Create checkpoint',
  'Укажите название контрольной точки.': 'Enter a checkpoint name.',
  'Добавьте хотя бы одну фотографию или видео.': 'Add at least one photo or video.',
  'Укажите дату и время контрольной точки.': 'Enter the checkpoint date and time.',
  'Добавьте маршруты, по которым вы регулярно выполняете поездки': 'Add routes that you travel regularly',
  'Документы и верификация': 'Documents and verification',
  'Загружайте фотографии к каждой завершённой перевозке.': 'Upload photos for every completed transport.',
  'Загрузите документы для проверки, чтобы получить доступ к откликам на заказы': 'Upload documents for verification to start sending offers',
  'Изменить': 'Edit',
  'Изменить фото профиля': 'Change profile photo',
  'История': 'History',
  'Как написать хороший текст о себе': 'How to write a good profile description',
  'Требования к фотографиям портфолио': 'Portfolio photo requirements',
  'Покажите реальные условия перевозки и заботу о питомцах. После модерации фотографии увидят заказчики.': 'Show real transport conditions and how you care for pets. Customers will see the photos after moderation.',
  'Какие фотографии подходят': 'Suitable photos',
  'Питомец в дороге, при передаче или прибытии.': 'A pet during the journey, handover or arrival.',
  'Переноска, салон автомобиля и безопасное размещение.': 'A pet carrier, vehicle interior and safe placement.',
  'Кормление, прогулка и другие этапы поездки.': 'Feeding, walks and other stages of the journey.',
  'Технические требования': 'Technical requirements',
  'JPG, PNG или WEBP размером до 10 МБ.': 'JPG, PNG or WEBP up to 10 MB.',
  'Чёткое изображение без сильного размытия и водяных знаков.': 'A clear image without heavy blur or watermarks.',
  'Без телефонов, email и других контактных данных в кадре или подписи.': 'Do not include phone numbers, email addresses or other contact details in the image or caption.',
  'В рейтинг входят одобренные фотографии: каждая добавляет 2,5%, 40 фотографий дают 100%.': 'Approved photos count toward the rating: each adds 2.5%, and 40 photos give a 100% rating.',
  'Напишите 3–6 коротких предложений, которые помогут заказчику понять ваш опыт и подход.': 'Write 3–6 short sentences that help customers understand your experience and approach.',
  'Расскажите главное': 'Cover the essentials',
  'Сколько лет вы перевозите животных и по каким направлениям.': 'How long you have transported animals and the routes you cover.',
  'Как обеспечиваете безопасность, комфорт и связь в дороге.': 'How you ensure safety, comfort and communication during the journey.',
  'На каком транспорте работаете и с какими питомцами есть опыт.': 'What vehicle you use and which pets you have experience with.',
  'Не публикуйте': 'Do not publish',
  'Телефон, email, ссылки на мессенджеры и соцсети.': 'Phone numbers, email addresses, messenger links or social media profiles.',
  'Цены и обещания, которые нельзя подтвердить.': 'Prices or promises that cannot be verified.',
  'Пример:': 'Example:',
  'Бережно перевожу собак и кошек по России и Европе. В дороге поддерживаю привычный режим питомца, регулярно отправляю фото и всегда остаюсь на связи с заказчиком.': 'I carefully transport dogs and cats across Russia and Europe. During the journey I maintain the pet’s usual routine, send regular photos and stay in touch with the customer.',
  'Понятно': 'Got it',
  'Карго-агент': 'Cargo agent',
  'Качество отчётов в пути': 'Journey report quality',
  'Клиенты пока не добавили видео к отзывам.': 'Customers have not added videos to their reviews yet.',
  'Лицензий можно загрузить несколько. Для авиакурьеров лицензия не требуется — достаточно паспорта и подтверждённого опыта.': 'You can upload several licences. Flight couriers only need a passport and verified experience.',
  'Лицензия ИП на грузоперевозки (1 из 2)': 'Road freight licence (1 of 2)',
  'Лицензия международные перевозки (2 из 2)': 'International transport licence (2 of 2)',
  'Личные данные (паспорт, номер карты, телефон) не отображаются': 'Personal details such as passport, bank card and phone are hidden',
  'Марка и модель': 'Make and model',
  'Маршруты не указаны': 'No routes specified',
  'Маршруты пока не добавлены': 'No routes added yet',
  'Недавние поездки': 'Recent trips',
  'Обо мне': 'About me',
  'Описание фото...': 'Photo description…',
  'Отклики доступны': 'Offers enabled',
  'Отклики закрыты': 'Offers disabled',
  'Ожидает цену от перевозчика': 'Awaiting a carrier price',
  'Ответ заказчика': 'Customer’s answer',
  'Паспорт ・ Лицензия ・ Портфолио': 'Passport ・ Licence ・ Portfolio',
  'перевозок выполнено': 'transports completed',
  'Письмо отправлено': 'Email sent',
  'Повторить отправку': 'Send again',
  'Подтвердить email': 'Confirm email',
  'Пока нет. Клиенты смогут прикреплять видео к отзывам о поездке.': 'None yet. Customers will be able to attach videos to trip reviews.',
  'Пока нет. Они появятся здесь после ваших первых завершённых поездок.': 'None yet. They will appear after your first completed trips.',
  'Показать все фотографии': 'Show all photos',
  'Получайте уведомления о новых заявках на этих маршрутах': 'Receive notifications about new requests on these routes',
  'Портфолио': 'Portfolio',
  'Портфолио перевозчика': 'Carrier portfolio',
  'Предпочитаемые маршруты': 'Preferred routes',
  'Предпросмотр профиля': 'Profile preview',
  'Предыдущие поездки': 'Previous trips',
  'Предыдущие фотографии': 'Previous photos',
  'Работа': 'Work',
  'Раздел кабинета': 'Account section',
  'Расскажите о себе, вашем опыте и подходе к перевозке...': 'Describe yourself, your experience and your approach to pet transport…',
  'Рейтинг верификации': 'Verification rating',
  'Свернуть фотографии': 'Collapse photos',
  'Следующие поездки': 'Next trips',
  'Следующие фотографии': 'Next photos',
  'Смотреть фото': 'View photos',
  'Сохранить изменения': 'Save changes',
  'Спросить публично': 'Ask publicly',
  'Счета и расчёты': 'Invoices and payments',
  'Транспорт': 'Vehicle',
  'Требования к загружаемым фотографиям': 'Photo upload requirements',
  'У перевозчика пока нет завершённых поездок на LOVO. Вы можете стать первым заказчиком!': 'This carrier has no completed LOVO trips yet. You can be their first customer!',
  'Уже откликнулись': 'Offers submitted',
  'У перевозчика пока нет отзывов. Вы можете стать первым заказчиком!': 'This carrier has no reviews yet. You can be the first!',
  'Удалить маршрут': 'Delete route',
  'Удалить фото автомобиля': 'Delete vehicle photo',
  'Фото авто': 'Vehicle photos',
  'Фото автомобиля': 'Vehicle photo',
  'Фото из портфолио перевозчика': 'Carrier portfolio photo',
  'Фото не добавлено': 'No photo added',
  'Фотографии автомобиля': 'Vehicle photos',
  'фотографию': 'photo',
  'Это превью — так ваш профиль выглядит для заказчика, открывшего ваш отклик.': 'This preview shows how your profile appears to a customer viewing your offer.',
  'Вернуться в личный кабинет': 'Return to account',
  'Пройти верификацию': 'Complete verification',
  'Показать ещё отзывы': 'Show more reviews',
  'Без верификации откликаться на заявки нельзя — клиенты доверяют только проверенным. Модерация занимает до 24 часов.': 'Verification is required before sending offers. Customers rely on verified carriers, and review takes up to 24 hours.',
  'верификация': 'verification',
  'Водительские права (если возите на авто)': 'Driving licence (for road transport)',
  'Год': 'Year',
  'Гос. номер': 'Registration number',
  'Грузовой фургон': 'Cargo van',
  'Для авиакурьеров лицензия не требуется. Для остальных — лицензия ИП/ООО на грузоперевозки, международная и т.п.': 'Flight couriers do not need a licence. Other carriers should upload their road freight, international or equivalent licence.',
  'Добавить ещё фото в портфолио': 'Add more portfolio photos',
  'Документы используем только для модерации, заказчикам не показываем — они видят только сумму рейтинга верификации.': 'Documents are used only for moderation and are not shown to customers. Customers see only your verification rating.',
  'Документы у нас — проверяем': 'Documents received · under review',
  'Доредактировать данные': 'Finish editing details',
  'Загружайте фото своих питомцев и животных, которых уже возили — заказчики видят это первым делом. Минимум 4 фото для прохождения верификации, ориентир для топ-перевозчика — 40+ фото с разных маршрутов и видов животных.': 'Upload photos of your own pets and animals you have transported. Customers see these first. Verification requires at least 4 photos; leading carriers usually have 40+ photos from different routes and animal types.',
  'Загружено': 'Uploaded',
  'Загрузите хотя бы один документ.': 'Upload at least one document.',
  'Загрузите 3–6 фото': 'Upload 3–6 photos',
  'Кондиционер': 'Air conditioning',
  'Лицензии (можно несколько)': 'Licences (multiple allowed)',
  'Микроавтобус': 'Minibus',
  'Минивэн': 'Minivan',
  'Название лицензии': 'Licence name',
  'Название лицензии (например: ИП на грузоперевозки)': 'Licence name (for example: road freight licence)',
  'Обычно справляемся за 12–24 часа. Пришлём SMS и письмо, как только всё проверим. Пока — можете смотреть заявки в ленте, но откликаться сможете после верификации.': 'Review normally takes 12–24 hours. We will send an SMS and email when it is complete. You can browse requests in the meantime, but offers require verification.',
  'Особенности для животных': 'Pet-friendly features',
  'Отдельный отсек': 'Separate compartment',
  'Открыть кабинет (просмотр заявок без откликов)': 'Open account (browse requests without sending offers)',
  'Отправить на модерацию': 'Submit for review',
  'Паспорт (главная страница)': 'Passport (main page)',
  'Перетащите фото или нажмите для загрузки': 'Drag photos here or click to upload',
  'Поилка в пути': 'Travel water bowl',
  'Пока модерация идёт, вы можете': 'While verification is in progress, you can',
  'Портфолио прошлых перевозок': 'Previous transport portfolio',
  'Публичные вопросы': 'Public questions',
  'Публичных вопросов пока нет': 'No public questions yet',
  'Последний шаг — документы': 'Final step · documents',
  'Регистрация перевозчика (6/6)': 'Carrier registration (6/6)',
  'Тип кузова': 'Vehicle type',
  'Укажите корректный год выпуска авто': 'Enter a valid vehicle year',
  'Укажите корректный год выпуска авто (не ранее 1900 года)': 'Enter a valid vehicle year (1900 or later)',
  'Укажите марку и модель транспорта.': 'Enter the vehicle make and model.',
  'Универсал': 'Estate car',
  'Файл': 'File',
  'Фиксация переноски': 'Carrier restraint',
  'Фото авто (внешний вид + салон)': 'Vehicle photos (exterior and interior)',
  'JPG, PNG · до 10 МБ · можно загружать до 50 фото': 'JPG, PNG · up to 10 MB · up to 50 photos',
  '+ Добавить ещё лицензию': '+ Add another licence',
};
